import isValidAction from './isValidCombatantAction'
import isCounters from './isCounters'
import isDelay from './isDelay'
import isLastCurrentActionDelaySelection from './isLastCurrentActionDelaySelection'
import isSameAsCurrentAction from './isSameAsCurrentAction'
//---------------------
// is valid action slot
//----------------------
export default function isValidActionSlot(parm) {
  // console.log("----------------------");
  // console.log("isValidActionSlot");
  if (
    parm.props?.row?.no_attack_reason &&
    parm.view_round == parm.arena_round &&
    parm.arena_extra_action > 0 &&
    parm.num == parm.arena_extra_action
  ) {
    return false
  }

  //-----------------------------------------------
  // invalid - cannot delay the last current action
  //-----------------------------------------------
  if (isLastCurrentActionDelaySelection(parm)) {
    return false
  }
  //---------------
  // set delay vars
  //---------------
  let delay_parm = {
    props: parm.props,
    num: parm.num,
  }
  let delay = isDelay(delay_parm)
  //-------------------
  // invalid - delayed
  //-------------------
  if (delay) {
    // console.log("invalid - delay");
    return false
  } else {
    let counters = isCounters(parm.props, parm.selected_marker)
    //-----------------------
    // invalid - on counters
    //-----------------------
    if (counters) {
      // console.log("invalid - counters");
      return false
      //----------------------------------------------
      // invalid - ahead of current action this round
      //----------------------------------------------
    } else if (
      parm.selected_action &&
      parm.view_round == parm.arena_round &&
      parm.num > parm.arena_action &&
      !isSameAsCurrentAction({
        row: parm.props?.row,
        selectedActionName: parm.selected_action.name,
        arenaAction: parm.arena_action,
      })
    ) {
      return false
      //-------------------------
      // invalid - future action
      //-------------------------
    } else if (parm.view_round > parm.arena_round) {
      // console.log("invalid - future round");
      return false
      //-------------------------
      // invalid - for combatant (if action not marker)
      //-------------------------
    } else if (
      parm.selected_action &&
      !isValidAction(parm.props.row['id'], parm.selected_action.name)
    ) {
      // console.log("invalid - combatant action");
      return false
    }
  }
  //------------
  // else valid
  //------------
  // console.log("valid - ok");
  return true
}
